import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-available-appointment-slot',
  templateUrl: './available-appointment-slot.component.html',
  styleUrls: ['./available-appointment-slot.component.css']
})
export class AvailableAppointmentSlotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
